import { QueryClient } from '@tanstack/react-query';
import { addressesAPI } from '../api/address';
import {
  clearGuestAddressPayload,
  getGuestAddressPayload,
} from '../libs/addressStorage';
import { captureApiError } from '../../../lib/sentry-utils';

// Called once the user authorizes: if an address was created locally as a
// guest (see useCreateAddress), push it to the backend now that we have an
// account to attach it to, then let the normal ['addresses'] fetch take over.
export const syncGuestAddressToBackend = async (
  queryClient: QueryClient
): Promise<void> => {
  const guestPayload = getGuestAddressPayload();
  if (!guestPayload) return;

  try {
    await addressesAPI.createAddress(guestPayload);
    clearGuestAddressPayload();
    queryClient.invalidateQueries({ queryKey: ['addresses'] });
  } catch (error) {
    captureApiError(error, '/api/addresses/create', 'POST');
  }
};
